import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'
import { Flex, Heading, Separator, Modal } from '@sketch/components'
import { Breadcrumbs } from '../../components/Breadcrumbs'
import PermissionWrapper from './PermissionWrapper'

const H3 = styled(Heading.H3)`
  margin: 20px 0;
`

const StyledSeparator = styled(Separator)`
  margin-top: 24px;
  margin-bottom: 4px;
`

const StyledModal = styled(Modal)`
  max-width: 705px;
  /* Fix for the double scrollbars */
  overflow-y: hidden;
`

// For making the scrollbar not reach the bottom of the modal,
// as we have there the footer
const StyledBody = styled(Modal.Body)`
  max-height: 57vh;
  overflow-y: auto;

  ${breakpoint('sm')`
    max-height: 65vh;
  `}

  & ${PermissionWrapper} {
    :nth-child(even) {
      background-color: ${({ theme }) => theme.colors.background.secondary.B};
    }
  }
`

const SharingModalHeader = styled(Flex)`
  flex: 2;
  flex-direction: column;
  margin-right: 16px;
`

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-top: 4px;
`

export {
  H3,
  StyledSeparator,
  StyledModal,
  StyledBody,
  SharingModalHeader,
  StyledBreadcrumbs,
}
